export const SAVE_PARTY_ITEMS_ACTION = "SAVE_PARTY_ITEMS_ACTION"
export const SAVE_PARTY_ITEMS_ACTION_SUCCESS = "SAVE_PARTY_ITEMS_ACTION_SUCCESS"


export const GO_BUTTON_PARTY_ITEM_ADD = 'GO_BUTTON_PARTY_ITEM_ADD'
export const GO_BUTTON_PARTY_ITEM_ADD_SUCCESS = 'GO_BUTTON_PARTY_ITEM_ADD_SUCCESS'

export const EDIT_PARTY_ITEM_ID = 'EDIT_PARTY_ITEM_ID'
export const EDIT_PARTY_ITEM_ID_SUCCESS = 'EDIT_PARTY_ITEM_ID_SUCCESS'

export const CHANNEL_ITEM_VIEW_DETAIL_ACTION = 'CHANNEL_ITEM_VIEW_DETAIL_ACTION'
export const CHANNEL_ITEM_VIEW_DETAIL_ACTION_SUCCESS = 'CHANNEL_ITEM_VIEW_DETAIL_ACTION_SUCCESS'

export const PARTY_ITEM_API_ERROR_ACTION = 'PARTY_ITEM_API_ERROR_ACTION'

